var nunjucks = require("nunjucks/browser/nunjucks-slim");
var env;
if (!nunjucks.currentEnv){
	env = nunjucks.currentEnv = new nunjucks.Environment([], undefined);
} else {
	env = nunjucks.currentEnv;
}
var configure = require("../js/filters/nunjucks-config.js")(env);
var dependencies = nunjucks.webpackDependencies || (nunjucks.webpackDependencies = {});
dependencies["macros/urls.j2"] = require( "macros/urls.j2" );
dependencies["cookies-alert-privacy.j2"] = require( "cookies-alert-privacy.j2" );




var shim = require("/jh/workspace/MonoWeb-Build-Release/monoweb/node_modules/nunjucks-loader/runtime-shim");


(function() {(nunjucks.nunjucksPrecompiled = nunjucks.nunjucksPrecompiled || {})["core/templates/cookies-alert.j2"] = (function() {
function root(env, context, frame, runtime, cb) {
var lineno = null;
var colno = null;
var output = "";
try {
var parentTemplate = null;
env.getTemplate("macros/urls.j2", false, "core/templates/cookies-alert.j2", false, function(t_2,t_1) {
if(t_2) { cb(t_2); return; }
t_1.getExported(context.getVariables(), frame, function(t_3,t_1) {
if(t_3) { cb(t_3); return; }
if(t_1.hasOwnProperty("helpUrl")) {
var t_4 = t_1.helpUrl;
} else {
cb(new Error("cannot import 'helpUrl'")); return;
}
context.setVariable("helpUrl", t_4);
output += "\n\n";
var t_5;
t_5 = runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "core")),"constants")),"cookiesBanner")),"enabled");
frame.set("isEnabled", t_5, true);
if(frame.topLevel) {
context.setVariable("isEnabled", t_5);
}
if(frame.topLevel) {
context.addExport("isEnabled", t_5);
}
output += "\n";
var t_6;
t_6 = runtime.inOperator(runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "core")),"siteConfig")),"siteGroup"),runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "core")),"constants")),"cookiesBanner")),"disabledSiteGroups"));
frame.set("inDisabledSiteGroup", t_6, true);
if(frame.topLevel) {
context.setVariable("inDisabledSiteGroup", t_6);
}
if(frame.topLevel) {
context.addExport("inDisabledSiteGroup", t_6);
}
output += "\n";
var t_7;
t_7 = runtime.inOperator(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "core")),"siteId"),runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "core")),"constants")),"cookiesBanner")),"disabledSiteIds"));
frame.set("inDisabledSiteIds", t_7, true);
if(frame.topLevel) {
context.setVariable("inDisabledSiteIds", t_7);
}
if(frame.topLevel) {
context.addExport("inDisabledSiteIds", t_7);
}
output += "\n";
var t_8;
t_8 = (lineno = 5, colno = 28, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "_get"), "_get", context, ["core.ab.SS_GDPR_MODAL",""])) == 1;
frame.set("gdprModalEnabled", t_8, true);
if(frame.topLevel) {
context.setVariable("gdprModalEnabled", t_8);
}
if(frame.topLevel) {
context.addExport("gdprModalEnabled", t_8);
}
output += "\n\n";
if(!runtime.contextOrFrameLookup(context, frame, "isEnabled") || runtime.contextOrFrameLookup(context, frame, "inDisabledSiteGroup") || runtime.contextOrFrameLookup(context, frame, "inDisabledSiteIds") || runtime.contextOrFrameLookup(context, frame, "gdprModalEnabled")) {
output += "\n    ";
var t_9;
t_9 = true;
frame.set("disableBanner", t_9, true);
if(frame.topLevel) {
context.setVariable("disableBanner", t_9);
}
if(frame.topLevel) {
context.addExport("disableBanner", t_9);
}
output += "\n";
;
}
output += "\n\n<div class=\"js-cookies-alert dom-cookies-alert\">\n\n    ";
if(!runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "core")),"userHasAgreedToCookies") && !runtime.contextOrFrameLookup(context, frame, "disableBanner") && !(lineno = 13, colno = 74, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "_get"), "_get", context, ["renderCache.usingPwaHeaderFooter",runtime.contextOrFrameLookup(context, frame, "False")]))) {
output += "\n\n        <div class=\"c-cookies-alert\">\n\n            <div class=\"o-row\">\n\n                <div class=\"g-cookies-alert__inner c-cookies-alert__inner\">\n\n                    <div class=\"g-cookies-alert__disclaimer\">\n                        ";
env.getTemplate("cookies-alert-privacy.j2", false, "core/templates/cookies-alert.j2", null, function(t_12,t_10) {
if(t_12) { cb(t_12); return; }
t_10.render(context.getVariables(), frame, function(t_13,t_11) {
if(t_13) { cb(t_13); return; }
output += t_11
output += "\n\n                    </div>\n\n                    <div class=\"g-cookies-alert__button\">\n\n                        <button class=\"c-button-primary c-cookies-alert__button js-agree-to-cookies\" type=\"button\">\n                            ";
output += runtime.suppressValue((lineno = 29, colno = 29, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "t"), "t", context, ["cookies_alert_ok_button"])), env.opts.autoescape);
output += "\n                        </button>\n\n                    </div>\n\n                </div>\n\n            </div>\n\n        </div>\n    ";
})});
}
output += "\n</div>\n";
if(parentTemplate) {
parentTemplate.rootRenderFunc(env, context, frame, runtime, cb);
} else {
cb(null, output);
}
})});
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
return {
root: root
};

})();
})();



module.exports = shim(nunjucks, env, nunjucks.nunjucksPrecompiled["core/templates/cookies-alert.j2"] , dependencies)